import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy, AfterViewInit, OnChanges, SimpleChanges,
  Output, EventEmitter } from '@angular/core';
import _ from 'lodash';
import { MemberService } from './../../../../../rest/api/member.service';
import { AuthService } from './../../../../../services/auth.service';

@Component({
  selector: 'app-edit-virtual-tours-video',
  templateUrl: './edit-virtual-tours-video.component.html',
  styleUrls: ['./edit-virtual-tours-video.component.scss']
})
export class EditVirtualToursVideoComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit  {
  accessToken: any;
  toggle = true;

  @Input() spaceData;
  @Input() mediaData;
  @Input() floorplanData;
  @Input() selectedMedia;
  @Output() closeEditVirtualToursEmit = new EventEmitter();
  @ViewChild('cssRendererEditContainer') cssRendererEditContainer: ElementRef;
  @ViewChild('rendererVideoContainer') rendererVideoContainer: ElementRef;
  @ViewChild('videoElementEdit') videoElementEdit: ElementRef;
  // @ViewChild('tagDiv') tagDivContainer: ElementRef;
  @Output() seletedMediaEmit = new EventEmitter();
  @Output() changeSpaceConfigEmit = new EventEmitter();

  pointerEventsNone = false;
  cursorPointer = false;

  loading = true;
  playIconClicked = true;
  volumeIconClicked = false;
  isVideoPlaying = true;
  fullScreen = false;
  // three js basic controls
  animateId: any;
  controls = null;
  title = null;
  renderer = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2(0, 0);
  manualControl = false;

  // Canvas config
  CANVAS_HEIGHT = 850;
  CANVAS_WIDTH = 1200;
  CANVAS_CENTER_X = 0;
  CANVAS_CENTER_Y = 0;

  sphereMesh = [];
  currentMesh: any;

  // VR effect
  effect: any;
  stereoEffect = false;

  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1
  };

  toolTipHover = false;

  // Camera rotation codes
  cameraConfig = {
    isUserInteracting: false,
    onMouseDownMouseX: 0,
    onMouseDownMouseY: 0,
    lon: 0,
    onMouseDownLon: 0,
    lat: 0,
    onMouseDownLat: 0,
    phi: 0,
    theta: 0,
    clientX: 0,
    clientY: 0,
    controlsSpeed: 600
  };

  // Opacity
  opacities = [];

  videoTexture: any;
  videoTime = 0;
  videoDuration = 0;

  hotspotColor = '#ffc378';
  hotspotMesh = [];
  editHotspots: any;

  cssScene = null;
  cssRenderer = null;


  videoTitleEnable = false;
  clickedPosition: any;
  currentTextMesh: any;
  currentTextGeometry: any;
  currentTextFont: any;

  isInfoModalClosed = false;

  setTimeoutValue = [];
  intervalTime: any;
  isBuffering = false;

  constructor(
    public memberService: MemberService,
    private authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.initScene();
  }

  initScene() {
    this.scene = new THREE.Scene();
    // Css renderer
    this.cssScene = new THREE.Scene();
    this.cssRenderer = new THREE.CSS3DRenderer();
    this.renderer = new THREE.WebGLRenderer( { antialias: true } );
  }

  ngOnInit() {
    const thisobject = this;
    // tslint:disable-next-line:only-arrow-functions
    $('body').on('click', '.hotspot-video-text', function(event) {
      if ($(this).attr('id')) {
        thisobject.hotspotClickedEvent($(this).attr('id'));
      }
    });

    $('body').on('click', '#custom-seekbar', function(e) {
      const offset = $(this).offset();
      const left = (e.pageX - offset.left);
      const totalWidth = $('#custom-seekbar').width();
      const percentage = ( left / totalWidth );
      const vidTime = thisobject.videoElementEdit.nativeElement.duration * percentage;
      thisobject.videoElementEdit.nativeElement.currentTime = vidTime;
      thisobject.clearVideoTime();
    }); // click()

  }

  hotspotClickedEvent(uuid) {
    const hotspotMesh = _.find(this.hotspotMesh , {name: uuid });
    const hotspotData =  _.find(this.selectedMedia.hotspot , {uuid});
    if (hotspotData) {
      this.editHotspots = hotspotData;
      this.videoTitleEnable = true;
      this.currentTextMesh = hotspotMesh;
      this.videoElementEdit.nativeElement.pause();
      let i;
      for ( i = 0; i < this.setTimeoutValue.length; i++) {
        clearTimeout(this.setTimeoutValue[i]);
      }
    }
  }

  getCurrentVideoTime(event) {
    if (!this.videoTitleEnable && this.isVideoPlaying) {
      // For progress bar
      const percentage = ( this.videoElementEdit.nativeElement.currentTime / this.videoElementEdit.nativeElement.duration ) * 100;
      $('#custom-seekbar span').css('width', percentage + '%');

      this.videoTime = event.target.currentTime;
      // console.log('this.videoTime', this.videoTime);
      if (this.videoElementEdit.nativeElement.networkState === this.videoElementEdit.nativeElement.NETWORK_LOADING ||  this.videoElementEdit.nativeElement.readyState <  this.videoElementEdit.nativeElement.HAVE_FUTURE_DATA) {
        this.isBuffering = true;
      } else {
        if (this.isBuffering) {
          this.isBuffering = false;
        }
      }
      let i;
      for ( i = 0; i < this.hotspotMesh.length; i++) {
        const singleMesh = this.hotspotMesh[i];
        let userTime = 0;
        if (singleMesh && singleMesh.userData && singleMesh.userData.time && singleMesh.userData.time !== '') {
          // tslint:disable-next-line:radix
          userTime =  parseInt(singleMesh.userData.time);
          if (isNaN(userTime)) {
            userTime = 0;
          }
        }
        if (singleMesh.name !== 'new_link') {
          if (singleMesh && singleMesh.userData && this.videoTime && this.videoTime >= userTime && this.videoTime < (userTime + 5)) {
            this.showTextDiv(singleMesh.userData);
            this.setTimeoutValue.push(setTimeout(() => {
              this.hideTextDiv(singleMesh.userData);
            }, 5000));
          }
        }
      }
    }
  }

  showTextDiv(hotspot) {
    if ($('#' + hotspot.uuid)) {
      $('#' + hotspot.uuid).css( {
        visibility: 'visible',
        opacity: 1
      });
    }
  }

  hideTextDiv(hotspot) {
    if ($('#' + hotspot.uuid)) {
      $('#' + hotspot.uuid).css( {
        visibility: 'hidden',
        opacity: 0
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.init();
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes.spaceData && changes.spaceData.currentValue) {
        this.updateSpaceConfig(changes.spaceData.currentValue.config);
      }
  }

  updateSpaceConfig(configData) {
    this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
    this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
    this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
    this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
  }

  onMouseMove( event ) {

    // if (this.camera && event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') {
    if (this.camera) {
      // Image rotation
      if ( this.cameraConfig.isUserInteracting === true ) {
        if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
          this.cameraConfig.clientX = event.clientX || (event.tources && event.tources[0] && event.touches[ 0 ].clientX ? event.touches[ 0 ].clientX : 0);
          this.cameraConfig.clientY = event.clientY || (event.tources && event.tources[0] && event.touches[ 0 ].clientY ? event.touches[ 0 ].clientY : 0);

          // tween opacity back to originals
          const targetLat = ( this.cameraConfig.clientY - this.cameraConfig.onMouseDownMouseY ) * 0.2 + this.cameraConfig.onMouseDownLat;
          const targetLon = ( this.cameraConfig.onMouseDownMouseX - this.cameraConfig.clientX ) * 0.2 + this.cameraConfig.onMouseDownLon;

          if (targetLat && targetLon) {
            const tweenOpacity = new TWEEN.Tween(this.cameraConfig)
              .to({ lat: targetLat, lon: targetLon}, this.cameraConfig.controlsSpeed)
              .easing(TWEEN.Easing.Quadratic.Out)
              .onUpdate(() => {
              })
              .onComplete(() => {
              });
            tweenOpacity.start();
          }
          this.manualControl = true;
          const canvasBounds = this.renderer.context.canvas.getBoundingClientRect();
          this.mouse.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
          this.mouse.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
        }
      }
    }
  }

  onMouseDown(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
        this.manualControl = false;
        this.cameraConfig.isUserInteracting = true;
        this.cameraConfig.clientX = (event && event.clientX) || (event && event.touches[ 0 ].clientX);
        this.cameraConfig.clientY = (event && event.clientY) || (event && event.touches[ 0 ].clientY);
        this.cameraConfig.onMouseDownMouseX = this.cameraConfig.clientX;
        this.cameraConfig.onMouseDownMouseY = this.cameraConfig.clientY;
        this.cameraConfig.onMouseDownLon = this.cameraConfig.lon;
        this.cameraConfig.onMouseDownLat = this.cameraConfig.lat;
      }
    }
  }

  onMouseUp(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
        const mousePosition = new THREE.Vector2();
        const canvasBounds = this.renderer.context.canvas.getBoundingClientRect();
        mousePosition.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
        mousePosition.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
        this.cameraConfig.isUserInteracting = false;
        // Camera rotation and sphere rotation
        if (!this.manualControl && !this.videoTitleEnable) {
          if (event.target && event.target.className && event.target.className === 'text-block') {
            return;
          }
          const rayCaster = new THREE.Raycaster();
          rayCaster.setFromCamera(mousePosition, this.camera);
          // this.raycaster.setFromCamera( this.mouse, this.camera );
          const intersects = rayCaster.intersectObjects( this.scene.children, true );
          if ( intersects.length > 0 ) {
            this.editHotspots = undefined;
            if (!this.isInfoModalClosed) {
              this.closeInfoModal();
            }
            this.videoTitleEnable = true;
            this.playIconClicked = false;
            this.videoElementEdit.nativeElement.pause();
            this.clickedPosition = intersects[0].point;
            this.addNewTextMesh();
          }
        }
      }
    }
  }

  init() {

    this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).width));
    this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).height));
    this.CANVAS_CENTER_X = this.CANVAS_WIDTH / 2;
    this.CANVAS_CENTER_Y = this.CANVAS_HEIGHT / 2;

    // Css renderer
    this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.cssRenderer.domElement.style.position = 'absolute';
    this.cssRenderer.domElement.style.top = 0;
    this.cssRendererEditContainer.nativeElement.appendChild(this.cssRenderer.domElement);

    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.renderer.setClearColor('#0C7CA5', 0);

    this.rendererVideoContainer.nativeElement.appendChild(this.renderer.domElement);
    // Web vr
    // this.renderer.vr.enabled = true;
    // this.rendererVideoContainer.nativeElement.appendChild( WEBVR.createButton( this.renderer, { frameOfReferenceType: 'head-model' } ) );

    this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );
    this.camera.target = new THREE.Vector3( 0, 0, 0 );
    // this.playIconClicked = this.spaceConfig.auto_rotate ? true : false;
    // VR effect
    // Add the VR screen effect.
    this.effect = new THREE.StereoEffect(this.renderer);
    // this.effect.eyeSeparation = 5;
    this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );


    // scene
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );

    this.createVideoSphere();
    this.animate();
  }

  createVideoSphere() {
    const geometry = new THREE.SphereBufferGeometry( 500, 60, 40 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );
    this.videoElementEdit.nativeElement.muted = true;
    this.videoElementEdit.nativeElement.loop = true;
    this.videoElementEdit.nativeElement.muted = true;
    this.videoElementEdit.nativeElement.setAttribute( 'webkit-playsinline', 'webkit-playsinline' );
    this.videoElementEdit.nativeElement.play();
    this.videoTexture = new THREE.VideoTexture( this.videoElementEdit.nativeElement );
    this.videoTexture.minFilter = THREE.LinearFilter;
    this.videoTexture.format = THREE.RGBFormat;
    const material = new THREE.MeshBasicMaterial( { map: this.videoTexture } );
    this.sphereMesh = new THREE.Mesh( geometry, material );
    this.scene.add( this.sphereMesh );
    this.videoDuration = this.videoElementEdit.nativeElement.duration;
    this.insertTextMesh();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  // addNewTextMesh() {

  //   this.currentTextMesh = new THREE.Mesh( new THREE.Geometry(), new THREE.MeshPhongMaterial( { color: 0x00fffc } ));
  //   this.scene.add( this.currentTextMesh );

  //   const textLoader = new THREE.TTFLoader();
  //   textLoader.load('/assets/js/threejs/Poppins-Medium.ttf', (data) => {
  //     this.currentTextFont = new THREE.FontLoader().parse(data);
  //     this.createTextMesh('');
  //     this.videoTitleEnable = true;
  //   });
  // }

  // generateGeometry(text) {
  //   const font = this.currentTextFont;
  //   const geometry = new THREE.TextGeometry( text, {
  //     font,
  //     size: 1,
  //     height: 0.5
  //   });

  //   geometry.computeBoundingBox();
  //   geometry.center();
  //   this.currentTextMesh.geometry.dispose();
  //   this.currentTextMesh.geometry = geometry;
  //   this.scene.add( this.currentTextMesh );
  //   this.animate();
  // }


  // createTextMesh(text) {
  //   const font = this.currentTextFont;
  //   this.currentTextGeometry = new THREE.TextBufferGeometry(text, {
  //     font,
  //     size: 1,
  //     height: 0.5
  //   });
  //   this.currentTextMesh = new THREE.Mesh(this.currentTextGeometry,
  //     new THREE.MeshStandardMaterial({
  //       color: 'pink',
  //       metalness: 0.0,
  //       roughness: 0.5
  //     })
  //   );
  //   this.currentTextMesh.name = 'new_link';
  //   this.currentTextMesh.position.set(this.clickedPosition.x * 0.1, this.clickedPosition.y * 0.1, this.clickedPosition.z * 0.1);
  //   // this.currentTextMesh.visible = false;
  //   this.hotspotMesh.push(this.currentTextMesh);
  //   this.scene.add(this.currentTextMesh);
  //   // this.currentTextMesh = this.currentTextMesh;
  //   // this.updateMetaTagsRotationOnMouseMove();
  // }

  inputChangeEmit(value) {
    if (this.currentTextMesh) {
      let element;
      if (this.currentTextMesh.name === 'new_link') {
        element = $('#new_link');
      } else {
        element = $('#' + this.currentTextMesh.name);
      }
      if (element) {
        const children = element.find('.text-block');
        if (children) {
          children.html(value);
        }
      }
    }
  }

  insertTextMesh() {
    if (this.selectedMedia.hotspot && this.selectedMedia.hotspot.length) {
      const hotspotData = this.selectedMedia.hotspot;
      let i;
      for (i = 0; i < hotspotData.length; i++) {
        const hotspots = hotspotData[i];
        this.createMediaHotspot(hotspots);
      }
    }
  }

  createMediaHotspot(hotspot) {
    const color = hotspot.color ? hotspot.color : this.hotspotColor;
    let content = '';
    content += '<div class="hotspot-video-text" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" style="visibility: hidden;opacity: 0;">';
    content += '<div class="text-block" style="color: ' + color + '">' + hotspot.title +  '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS3DObject( element );
    sprite.scale.set(0.1, 0.1, 0.1);

    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.userData = hotspot;
    this.hotspotMesh.push(sprite);
    this.cssScene.add( sprite );
  }

  addNewTextMesh() {
    const color = this.hotspotColor;
    let content = '';
    content += '<div class="hotspot-video-text" data-id="new_link" id="new_link" style="visibility: visible;opacity: 1;">';
    content += '<div class="text-block" style="color: ' + color + '"></div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS3DObject( element );
    sprite.scale.set(0.1, 0.1, 0.1);

    sprite.position.set(this.clickedPosition.x * 0.1, this.clickedPosition.y * 0.1, this.clickedPosition.z * 0.1);
    sprite.name = 'new_link';
    this.currentTextMesh = sprite;
    this.hotspotMesh.push(sprite);
    this.cssScene.add( sprite );
  }


  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    if (this.camera) {
      this.cameraConfig.lat = Math.max( - 85, Math.min( 85, this.cameraConfig.lat ) );
      this.cameraConfig.phi = THREE.Math.degToRad( 90 - this.cameraConfig.lat );
      this.cameraConfig.theta = THREE.Math.degToRad( this.cameraConfig.lon );
      this.camera.target.x = 500 * Math.sin( this.cameraConfig.phi ) * Math.cos( this.cameraConfig.theta );
      this.camera.target.y = 500 * Math.cos( this.cameraConfig.phi );
      this.camera.target.z = 500 * Math.sin( this.cameraConfig.phi ) * Math.sin( this.cameraConfig.theta );
      this.camera.lookAt( this.camera.target );
      this.updateMetaTagsRotationOnMouseMove();
      TWEEN.update();
      this.render();
    }
  }

  render() {
    if (this.renderer) {
      if (this.stereoEffect) {
        this.effect.render(this.scene, this.camera);
      } else {
        this.renderer.render(this.scene, this.camera);
      }
    }

    if (this.cssRenderer) {
      this.cssRenderer.render( this.cssScene, this.camera );
    }

  }

  resizeHandler(event) {
    if (this.renderer) {
      this.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).width));
      this.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererVideoContainer.nativeElement).height));

      this.camera.aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
    // Vr effect
    if (this.effect) {
      this.effect.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }

    // Css renderer
    if (this.cssRenderer) {
      this.cssRenderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    }
  }

  ngOnDestroy() {
    this.removeComponentProperties();
  }

  enableVrMode() {
    this.stereoEffect = !this.stereoEffect;
    this.resizeHandler(true);
    this.render();
  }

  removeComponentProperties() {

    const gl = this.renderer.getContext('webgl');
    if (gl) {
      try {
        gl.getExtension('WEBGL_lose_context').loseContext();
      } catch {
        console.log('error');
      }
    }

    this.removeCssComponents();

    cancelAnimationFrame(this.animateId); // Stop the animation
    this.renderer.domElement.addEventListener('dblclick', null, false); // remove listener to render
    if (this.sphereMesh) {
      this.scene.remove(this.sphereMesh);
    }
    this.sphereMesh = undefined;
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererVideoContainer.nativeElement);
    this.empty(this.cssRendererEditContainer.nativeElement);
    this.removeData();
  }

  removeCssComponents() {
    // if ($('.hotspot-pulse')) {
    //   $('.hotspot-pulse').each(function() {
    //     $(this).remove();
    //   });
    // }
    // if ($('.info-outer')) {
    //   $('.info-outer').each(function() {
    //     $(this).remove();
    //   });
    // }
    // let i;
    // for (i = 0; i < this.hotspotsMesh.length; i++) {
    //     if (this.hotspotsMesh[i]) {
    //       this.cssScene.remove(this.hotspotsMesh[i]);
    //     }
    // }
    // this.hotspotsMesh = [];
    // // Remove info hotspot mesh
    // let j;
    // for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
    //     if (this.hotspotsInfoMesh[j]) {
    //       this.cssScene.remove(this.hotspotsInfoMesh[j]);
    //     }
    // }
    // this.hotspotsInfoMesh = [];
}

  empty(elem) {
    while (elem.lastChild) {
      elem.removeChild(elem.lastChild);
    }
  }

  removeData() {
    this.cameraConfig.lat = 0;
    this.cameraConfig.lon = 0;
    this.sphereMesh = null;
  }

  closeEditVirtualTours() {
    this.removeComponentProperties();
    this.closeEditVirtualToursEmit.emit(true);
  }

  publishSpace() {
    this.memberService.publishSpace({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.spaceData.status = response && response.data && response.data.status ? response.data.status : this.spaceData.status;
    });
  }

  changeSpaceConfig(config) {
    this.changeSpaceConfigEmit.emit(config);
  }

  toggleMenuEmit(response) {
    this.toggle = response;
  }

  emptyMediaEmit(event) {
    this.closeEditVirtualTours();
    if ($('#deleteBtnClose')) {
      $('#deleteBtnClose').click();
    }
  }

  getPlayPauseText() {
    if (this.playIconClicked) {
      return 'Pause';
    }
    return 'Play';
  }

  getPlayPauseVideoText() {
    if (this.isVideoPlaying) {
      return 'Pause';
    }
    return 'Play';
  }

  playPauseVideo() {
    if (this.isVideoPlaying) {
        this.isVideoPlaying = false;
        this.videoElementEdit.nativeElement.pause();
        this.clearVideoTime();
    } else {
      this.isVideoPlaying = true;
      this.videoElementEdit.nativeElement.play();
    }
  }

  clearVideoTime() {
    let i;
    for ( i = 0; i < this.setTimeoutValue.length; i++) {
      clearTimeout(this.setTimeoutValue[i]);
    }
    const percentage = ( this.videoElementEdit.nativeElement.currentTime / this.videoElementEdit.nativeElement.duration ) * 100;
    $('#custom-seekbar span').css('width', percentage + '%');
  }

  getmuteUnmuteText() {
    if (!this.volumeIconClicked) {
      return 'Unmute';
    }
    return 'Mute';
  }

  muteUnmuteVideo() {
    this.volumeIconClicked = !this.volumeIconClicked;
    if (this.volumeIconClicked) {
      this.videoElementEdit.nativeElement.muted = false;
    } else {
      this.videoElementEdit.nativeElement.muted = true;
    }
  }

  playPauseVirtualTours() {
    if (this.playIconClicked) {
        this.playIconClicked = false;
        this.videoElementEdit.nativeElement.pause();
    } else {
      this.playIconClicked = true;
      this.videoElementEdit.nativeElement.play();
    }
  }

  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.hotspotMesh.length; i++) {
      const ringMesh = this.hotspotMesh[i];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
      // ringMesh.lookAt( this.camera.position );
    }
  }

  closeHotSpotBoxEmit(event) {
    this.videoTitleEnable = false;
    this.manualControl = false;
    if (this.currentTextMesh && this.currentTextMesh.name === 'new_link') {
      if ($('new_link')) {
        $('new_link').remove();
      }
      this.cssScene.remove(this.currentTextMesh);
      this.currentTextMesh = undefined;
      this.isVideoPlaying = true;
      this.videoElementEdit.nativeElement.play();
    } else {
      this.currentTextMesh = undefined;
      this.isVideoPlaying = true;
      this.videoElementEdit.nativeElement.play();
    }
  }

  closeInfoModal() {
    const element = document.getElementById('closeInfoModalBtn');
    if (element) {
      this.isInfoModalClosed = true;
      element.click();
    }
  }

  closeInfoModalUpdate() {
    this.isInfoModalClosed = true;
  }

  changeColorEmit(value) {
    let element;
    if (this.editHotspots) {
      element = $('#' + this.editHotspots.uuid);
    } else {
      element = $('#new_link');
    }
    if (element) {
        const children = element.find('.text-block');
        if (children) {
          children.css({color: value});
        }
    }
  }

  deleteHotspotEmit(event) {
    if (event.uuid) {
      // Delete hotspot for link hotspot
      this.selectedMedia.hotspot = _.filter(this.selectedMedia.hotspot, (hotspot) => {
        return hotspot.uuid !== event.uuid;
      });
      if ($('#' + event.uuid)) {
        $('#' + event.uuid).remove();
      }
    }
    this.cssScene.remove(this.currentTextMesh);
    this.currentTextMesh = undefined;
    this.videoTitleEnable = false;
    this.manualControl = false;
    this.isVideoPlaying = true;
    this.videoElementEdit.nativeElement.play();
  }

  createHotspotEmit(response) {
    this.currentTextMesh.name = response.uuid;
    this.hotspotMesh = _.map(this.hotspotMesh, (hotspot) => {
      if (hotspot.name === 'new_link') {
        hotspot.name = response.uuid;
        hotspot.userData = response;
      }
      return hotspot;
    });
    if ($('#new_link')) {
      $('#new_link').attr('data-id', response.uuid);
      $('#new_link').attr('id', response.uuid);
      this.hideTextDiv(response);
    }
    this.videoTitleEnable = false;
    this.selectedMedia.hotspot.push(response);
    this.isVideoPlaying = true;
    this.videoElementEdit.nativeElement.play();
  }

  updateHotspotEmit(response) {
    this.selectedMedia.hotspot = _.map(this.selectedMedia.hotspot, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        return response;
      }
      return hotspot;
    });
    this.hotspotMesh = _.map(this.hotspotMesh, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        hotspot.userData = response;
      }
      return hotspot;
    });
    this.hideTextDiv(response);
    this.videoTitleEnable = false;
    this.isVideoPlaying = true;
    this.videoElementEdit.nativeElement.play();
  }


}
